export interface IMentorCompletionsList {
    firstContactAttempts: IMentorCompletionsDetail[],
    firstContactsMade: IMentorCompletionsDetail[],
    workupSurveys: IMentorCompletionsDetail[],
    preOpSurveys: IMentorCompletionsDetail[],
    atSurgerySurveys: IMentorCompletionsDetail[],
    postSurgerySurveys: IMentorCompletionsDetail[],
    donationsMade: IMentorCompletionsDetail[]
}

export interface IMentorCompletionsDetail {
    id: number,
    userId: number,
    firstName: string,
    lastName: string,
    phoneNumber: string,
    email: string,
    completionDate: string,
    compType: string
}
